'use strict';

(function() {
    angular.module('app').service('ZoneShapeGroupDrawing', ZoneShapeGroupDrawing);

    ZoneShapeGroupDrawing.$inject = ['$timeout', 'CookieManagerService'];

    function ZoneShapeGroupDrawing($timeout, CookieManagerService) {
        function Constructor(sd, zones, groups) {
            this.sd = sd;
            this.overlays = [];
            this.inited = false;

            this.colors = {};

            this.zones = {
                list: zones,
                filtered: [],
                show: false,
            };

            this.groups = {
                list: groups,
                filtered: [],
                show: false,
            };

            this.cookies = {
                names: false,
                zones: [],
                groups: [],
            };

            this.initCookies();

            this.reload('zones', false);
            this.reload('groups', false);

            var _self = this;

            $timeout(function() {
                _self.inited = true;
            }, 200);
        }

        Constructor.prototype.initCookies = function() {
            var list = {
                names: false,
                zones: [],
                groups: [],
            };

            for (var key in list) {
                this.cookies[key] = CookieManagerService.get('zones.' + key, list[key]);
            }

            var fn = function(stored) {
                return this.filter(function(o) {
                    return stored.indexOf(o.id) >= 0;
                });
            };

            this.zones.filtered = fn.call(this.zones.list, this.cookies.zones);
            this.groups.filtered = fn.call(this.groups.list, this.cookies.groups);
        };

        Constructor.prototype.reload = function(type, extend) {
            var mapped = this[type].filtered.map(function(o) {
                return o.id;
            });
            CookieManagerService.set('zones.' + type, mapped);

            this[type].show = this[type].filtered.length === this[type].list.length;

            this.resetShapes(type);

            var bounds = this.loadZoneShapes(this.zones.filtered);
            var groups = this.loadGroupShapes(this.groups.filtered);

            extend && this.extendMapBounds(bounds.concat(groups));
        };

        Constructor.prototype.show = function(type) {
            this[type].show = !this[type].show;
            this[type].filtered = this[type].show ? this[type].list.slice() : [];

            this.reload(type, true);
        };

        Constructor.prototype.change = function(type) {
            if (!this.inited || (this[type].show && this[type].filtered.length === 0)) {
                return;
            }
            this[type].show = this[type].filtered.length === this[type].list.length;

            this.reload(type, true);
        };

        Constructor.prototype.toggleZoneNameOn = function() {
            this.cookies.names = !this.cookies.names;
            CookieManagerService.set('zones.names', this.cookies.names);

            this.reload('zones', false);
            this.reload('groups', false);
        };

        Constructor.prototype.resetShapes = function() {
            for (var index in this.overlays) {
                var overlay = this.overlays[index];
                overlay.setMap(null);
                google.maps.event.clearInstanceListeners(overlay);
                overlay = null;
            }

            this.overlays = [];
        };

        Constructor.prototype.fitZoneBounds = function(zone) {
            var data = this.sd.getShapeOverlay(this.sd.shapes[zone.type], zone.parameters, false);
            this.sd.map.fitBounds(data.bounds);

            return true;
        };

        Constructor.prototype.extendMapBounds = function(list) {
            if (!list.length) {
                return false;
            }

            var bounds = new google.maps.LatLngBounds();
            list.filter(function(o) {
                bounds.union(o);
            });

            this.sd.map.fitBounds(bounds);
        };

        Constructor.prototype.loadZoneShapes = function(zones) {
            this.sd.setDrawingState('reset');
            var bounds = [];

            for (var index in zones) {
                var zone = zones[index];

                var data = this.sd.getShapeOverlay(this.sd.shapes[zone.type], zone.parameters, false);
                data.overlay.setMap(this.sd.map);

                if (this.cookies.names) {
                    var box = document.createElement('div');

                    box.setAttribute('data-id', '' + zone.id + '');
                    box.innerHTML =
                        ' <div class="bubble without-arrow bubble-' + zone.id + '">' + zone.name + '</div> ';

                    box.onclick = this.fitZoneBounds.bind(this, zone);

                    var zoneInfoBox = new InfoBox({
                        boxClass: 'box-object-number-window bon-zone',
                        zIndex: 1,
                        disableAutoPan: 'false',
                        content: box,
                        visible: true,
                    });

                    zoneInfoBox.setPosition(data.bounds.getCenter());
                    zoneInfoBox.open(this.sd.map);

                    this.overlays.push(zoneInfoBox);
                }

                google.maps.event.addListener(data.overlay, 'click', this.fitZoneBounds.bind(this, zone));
                this.overlays.push(data.overlay);

                bounds.push(data.bounds);
            }

            return bounds;
        };

        Constructor.prototype.loadGroupShapes = function(groups) {
            this.sd.setDrawingState('reset');

            var bounds = [];

            for (var index in groups) {
                var group = groups[index];

                if (!this.colors.hasOwnProperty(group.id)) {
                    this.colors[group.id] = '#' + (0x1000000 + Math.random() * 0xffffff).toString(16).substr(1, 6);
                }

                for (var zoneIndex in this.zones.list) {
                    var zone = this.zones.list[zoneIndex];

                    if (zone.zoneGroupId === group.id) {
                        var data = this.sd.getShapeOverlay(
                            this.sd.shapes[zone.type],
                            zone.parameters,
                            false,
                            this.colors[group.id]
                        );
                        data.overlay.setMap(this.sd.map);

                        if (this.cookies.names) {
                            var box = document.createElement('div');
        
                            box.setAttribute('data-id', '' + zone.id + '');
                            box.innerHTML =
                                ' <div class="bubble without-arrow bubble-' + zone.id + '">' + zone.name + '</div> ';
        
                            box.onclick = this.fitZoneBounds.bind(this, zone);
        
                            var zoneInfoBox = new InfoBox({
                                boxClass: 'box-object-number-window bon-zone',
                                zIndex: 1,
                                disableAutoPan: 'false',
                                content: box,
                                visible: true,
                            });
        
                            zoneInfoBox.setPosition(data.bounds.getCenter());
                            zoneInfoBox.open(this.sd.map);
        
                            this.overlays.push(zoneInfoBox);
                        }

                        this.overlays.push(data.overlay);
                        bounds.push(data.bounds);
                    }
                }
            }

            return bounds;
        };

        return Constructor;
    }
})();
